import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  onCreate: () => void;
  primary?: boolean;
}

const EmptyState = ({ onCreate, primary }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-column align-center mg m-auto">
      <div className="noSite">
        <div className="image" />
      </div>
      <div className="noSite__title">{t("siteManagement.subTitle")}</div>
      <div className="noSite__desc">{t("siteManagement.info")}</div>
      <div className="createButton">
        <button
          type="button"
          onClick={onCreate}
          className={primary ? "btn btn-green mg mt-20" : "btn mg mt-20"}
          style={
            primary
              ? undefined
              : { backgroundColor: "#3182F6", color: "#fff", fontSize: 14 }
          }
        >
          <i className="icon_plus_white inline-block vertical-middle mg mr-10" />
          {t("siteManagement.createBtn")}
        </button>
      </div>
    </div>
  );
};

export default EmptyState;
